import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ReportFilters = ({ filters, onFilterChange, onGenerate, onReset, loading = false, disabled = false }) => {
  const periodOptions = [
    { value: 'current_month', label: 'Current Month' },
    { value: 'last_month', label: 'Last Month' },
    { value: 'current_quarter', label: 'Current Quarter' },
    { value: 'last_quarter', label: 'Last Quarter' },
    { value: 'current_year', label: 'Current Year' },
    { value: 'last_year', label: 'Last Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const comparisonOptions = [
    { value: 'none', label: 'No Comparison' },
    { value: 'previous_period', label: 'Previous Period' },
    { value: 'previous_year', label: 'Previous Year' },
    { value: 'budget', label: 'Budget' }
  ];

  const departmentOptions = [
    { value: 'all', label: 'All Departments' },
    { value: 'sales', label: 'Sales' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'operations', label: 'Operations' },
    { value: 'finance', label: 'Finance' },
    { value: 'hr', label: 'Human Resources' }
  ];

  const projectOptions = [
    { value: 'all', label: 'All Projects' },
    { value: 'proj_001', label: 'Website Redesign' },
    { value: 'proj_002', label: 'Mobile App Development' },
    { value: 'proj_003', label: 'Marketing Campaign Q1' },
    { value: 'proj_004', label: 'Infrastructure Upgrade' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <h3 className="font-heading font-semibold text-lg md:text-xl mb-4 md:mb-6">
        Report Parameters
      </h3>
      <div className="space-y-4 md:space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <Select
            label="Period"
            options={periodOptions}
            value={filters?.period}
            onChange={(value) => onFilterChange('period', value)}
            required
          />

          <Select
            label="Comparison"
            options={comparisonOptions}
            value={filters?.comparison}
            onChange={(value) => onFilterChange('comparison', value)}
          />
        </div>

        {filters?.period === 'custom' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            <Input
              label="Start Date"
              type="date"
              value={filters?.startDate}
              onChange={(e) => onFilterChange('startDate', e?.target?.value)}
              required
            />

            <Input
              label="End Date"
              type="date"
              value={filters?.endDate}
              onChange={(e) => onFilterChange('endDate', e?.target?.value)}
              required
            />
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <Select
            label="Department"
            description="Filter by department"
            options={departmentOptions}
            value={filters?.department}
            onChange={(value) => onFilterChange('department', value)}
          />

          <Select
            label="Project"
            description="Filter by project"
            options={projectOptions}
            value={filters?.project}
            onChange={(value) => onFilterChange('project', value)}
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <Button
            variant="default"
            onClick={onGenerate}
            iconName="FileText"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
            disabled={disabled || loading}
            loading={loading}
          >
            {loading ? 'Generating...' : 'Generate Report'}
          </Button>
          <Button
            variant="outline"
            onClick={onReset}
            iconName="RotateCcw"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
            disabled={loading}
          >
            Reset Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReportFilters;